import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './contact.reducer';

export const ContactDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const contactEntity = useAppSelector(state => state.contact.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="contactDetailsHeading">
          <Translate contentKey="crawlerBackendApp.contact.detail.title">Contact</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{contactEntity.id}</dd>
          <dt>
            <span id="initials">
              <Translate contentKey="crawlerBackendApp.contact.initials">Initials</Translate>
            </span>
          </dt>
          <dd>{contactEntity.initials}</dd>
          <dt>
            <span id="firstName">
              <Translate contentKey="crawlerBackendApp.contact.firstName">First Name</Translate>
            </span>
          </dt>
          <dd>{contactEntity.firstName}</dd>
          <dt>
            <span id="middleName">
              <Translate contentKey="crawlerBackendApp.contact.middleName">Middle Name</Translate>
            </span>
          </dt>
          <dd>{contactEntity.middleName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="crawlerBackendApp.contact.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{contactEntity.lastName}</dd>
          <dt>
            <span id="emailAddress">
              <Translate contentKey="crawlerBackendApp.contact.emailAddress">Email Address</Translate>
            </span>
          </dt>
          <dd>{contactEntity.emailAddress}</dd>
          <dt>
            <span id="phoneNumber">
              <Translate contentKey="crawlerBackendApp.contact.phoneNumber">Phone Number</Translate>
            </span>
          </dt>
          <dd>{contactEntity.phoneNumber}</dd>
          <dt>
            <span id="fax">
              <Translate contentKey="crawlerBackendApp.contact.fax">Fax</Translate>
            </span>
          </dt>
          <dd>{contactEntity.fax}</dd>
          <dt>
            <span id="language">
              <Translate contentKey="crawlerBackendApp.contact.language">Language</Translate>
            </span>
          </dt>
          <dd>{contactEntity.language}</dd>
          <dt>
            <span id="birthday">
              <Translate contentKey="crawlerBackendApp.contact.birthday">Birthday</Translate>
            </span>
          </dt>
          <dd>
            {contactEntity.birthday ? (
              <TextFormat value={contactEntity.birthday} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/contact" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/contact/${contactEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ContactDetail;
